console.log('aaaa');
$(document).ready(function() {
    $.validator.setDefaults({
        highlight: function (element) {
            $(element).addClass('is-invalid').removeClass('is-valid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid').addClass('is-valid');
        },
        errorElement: 'span',
        errorClass: 'help-block',
        errorPlacement: function (error, element) {
            //
        }
    });
    var submitter;
    $("button").click(function () {
        submitter = $(this).attr("id");
    });

    $('.needs-validation input').focus(function(e) {
        $('#succes-ticket').addClass('d-none');
    });

    $(".needs-validation").validate({
        invalidHandler: function(event, validator) {
            // 'this' refers to the form
            var errors = validator.numberOfInvalids();
            if (errors) {
                $('#error-input').removeClass('d-none');
            } else {
                $('#error-input').addClass('d-none');
            }
        },
        submitHandler: function (form) {
            $('#error-input').addClass('d-none');
            $('#error-ticket').addClass('d-none');
            $('#succes-ticket').addClass('d-none');
            $.post(window.base_url +"engine/validate-ticket.php", $(form).serializeArray(), function(data){
                if(data.success) {
                    $('#succes-ticket').removeClass('d-none');
                    if (submitter == 'submit-klaar') {
                        form.reset();
                    } else {
                        $('#ticketnummer').val('');
                    }
                } else {
                    if (data.full) $('#error-ticket').removeClass('d-none');
                }
            }, 'json');

        }
    });
});

